var map = {
	"./icon-arrow.png": "4088",
	"./icon-attention.png": "a4a1",
	"./icon-global.png": "0147",
	"./icon-management.png": "12be",
	"./icon-report.png": "6f43",
	"./icon-reservation.png": "e358"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dc80";